<template>
  <!-- PDF Content Here -->
  <div class="track-trace mx-2">
    <div class="d-flex justify-content-between align-items-center mt-1 ">
      <div class="d-flex align-items-center">
        <component
          class="color-base"
          style="width: 50px; fill: #2b938c"
          :is="isComponentIcon()"
        />
        <div class="color-base h3 ml-2 mb-0" style="width: 200px">
          {{
            isComponent() == "RoutingDetailsContainer"
              ? "Container Truck"
              : isComponent() == "RoutingDetailsLCL"
              ? "LCL"
              : isComponent() == "RoutingDetailsVan"
              ? "Van Container"
              : ""
          }}
        </div>
      </div>
      <div class="color-base h3">
        Order ID
        <span class="font-weight-bold">{{ request_quotation.id }}</span>
      </div>
    </div>
    <component
      v-if="shipment_detail"
      :is="isComponent()"
      :request_quotation="request_quotation"
      v-model="shipment_detail"
      :isPublic="isPublic"
    />
    <div class="d-flex flex-column">
      <ul class="track-trace_tabs group">
        <li
          v-for="(item, index) in trace_trace_list"
          :class="item.id == trace_group_select_id ? 'active' : ''"
          :key="index"
        >
          <a
            href="#one"
            @click="
              trace_group_select_id = item.id;
              trace_group_select = item.trace_group;
            "
            >{{ item.id }}</a
          >
        </li>
        <!-- <li class="active"><a href="#two">Two</a></li>
      <li><a href="#three">Three</a></li>
      <li><a href="#three">Four</a></li> -->
      </ul>

      <div class="d-flex">
        <div class="pl-3 py-3 mb-1 rounded mt-2 w-70">
          <div class="row" v-for="(p, stt) in trace_group_select" :key="p.id">
            <div
              class="col-3"
              v-if="p.children.filter((i) => i.selected).length > 0"
            >
              <div class="under-line">{{ stt + 1 }}. {{ p.text }}</div>
            </div>
            <div
              class="col-9 mt-2 pb-2"
              v-if="p.children.filter((i) => i.selected).length > 0"
            >
              <app-timeline>
                <app-timeline-item
                  v-for="t in p.children"
                  :key="t.id"
                  :title="t.name"
                  :subtitle="
                     t.HBL != null
                        ? t.date_ + ' - HBL: ' + t.HBL
                        : `${
                            t.truck_plate
                              ? '<b>Truck: </b>' + t.truck_plate
                              : ''
                          }  ${
                            t.driver_name
                              ? ' | <b>Driver Name: </b>' + t.driver_name
                              : ''
                          }  ${
                            t.driver_card_id
                              ? ' | <b>Card ID: </b>' + t.driver_card_id
                              : ''
                          }   ${
                            t.driver_phone
                              ? ' | <b>Phone: </b>' + t.driver_phone + '<br/> '
                              : ''
                          } 
                         ${t.cont_no ? ' <b>Cont No: </b>' + t.cont_no : ''} ${
                            t.seal_no
                              ? ' | <b>Seal No: </b>' + t.seal_no + '<br/>'
                              : ''
                          } 
                        <b>Date: </b>${t.date_} `
                      
                  "
                  time=""
                  variant="success"
                  :class="t.selected ? '' : 'hidden'"
                />
              </app-timeline>
            </div>
          </div>
        </div>
        <!-- <div v-if="isNoLogin" class="shipment-details w-30 ml-3">
          <b-card class="body-0">
            <h3 class="title-details text-primary pb-2">Shipment Details</h3>

            <ul class="p-0 m-0">
              <li class="list-details">
                <div class="title">Booking No:</div>
                <div class="title-id">{{ bookingInfo.id }}</div>
              </li>
              <li class="list-details">
                <div class="title">HBL. No:</div>
                <div class="title-id">{{ bookingInfo.hbl }}</div>
              </li>

              <li class="list-details">
                <div class="title">Carriers:</div>
                <div class="title-id">
                  {{ bookingInfo.shipping_line_name }}
                </div>
              </li>
              <li class="list-details">
                <div class="title">Container No:</div>
                <div class="title-id">{{ bookingInfo.cont_no }}</div>
              </li>
              <li class="list-details">
                <div class="title">Seal:</div>
                <div class="title-id">{{ bookingInfo.seal_no }}</div>
              </li>
            </ul>
          </b-card>
        </div> -->
      </div>
    </div>
  </div>
</template>
<style>
.table-print td {
  text-align: left;
}
.table-print th {
  text-align: center !important;
}
.table-print td,
.table-print th {
  border-bottom: 1px solid #333 !important;
  border-right: 1px solid #333 !important;
  padding: 4px 6px;
}
.table-print th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
  background-color: #2b938c;
  color: white;
}
</style>
<script>
import {
  VBTooltip,
  BImg,
  BDropdown,
  BDropdownItem,
  BButton,
  BFormTextarea,
  BFormInput,
  BFormCheckbox,
  BFormRadioGroup,
  BFormRadio,
  BFormGroup,
  BInputGroup,
  BInputGroupAppend,
  BInputGroupPrepend,
  BFormDatepicker,
  BRow,
  BCol,
  BTable,
  BCard,
  BCardText,
} from "bootstrap-vue";
import VueHtml2pdf from "vue-html2pdf";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import AppTimeline from "@core/components/app-timeline/AppTimeline.vue";
import AppTimelineItem from "@core/components/app-timeline/AppTimelineItem.vue";
import useJwt from "@/auth/jwt/useJwt";
import { mapState, mapActions } from "vuex";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import trackTrace from "@/mixin/trackTrace.js";
import RoutingDetailsContainer from "../V2/TrackTrace/RoutingDetailsContainer.vue";
import RoutingDetailsLCL from "../V2/TrackTrace/RoutingDetailsLCL.vue";
import RoutingDetailsVan from "../V2/TrackTrace/RoutingDetailsVan.vue";
import iconContainerTruck from "@/assets/images/pages/Container-Truck.svg";
import iconLCL from "@/assets/images/pages/lcl.svg";
import iconVAN from "@/assets/images/pages/Van.svg";

const status = {
  1.1: "Booking Submitted",
  1.2: "Received Booking Request",
  1.3: "Awaiting Quote Confirmation",
  1.4: "Received Edit Request",
  1.5: "Confirmed Quotation",
  2.1: "Release Booking",
  2.2: "Received Revise Request",
  2.3: "Planned Transportation",
  3.0: "Truck Information",
  3.1: "Empty Picked Up",
  3.2: "Arrived At The Warehouse",
  3.3: "Picked Up Cargo",
  3.4: "Delivered Cargo To The Port",
  3.5: "Reached The Receiving Location",
  3.6: "Picked Up Cargo",
  3.7: "Reached The Delivery Location",
  3.8: "Delivered Cargo",
  3.9: "Cargo Loaded",
  "3.10": "Arrived Destination Port",
  3.11: "Release",
  3.12: "Reached The Receiving Location",
  3.13: "Picked Up Cargo",
  3.14: "Reached The Delivery Location",
  3.15: "Delivered Cargo",
  3.16: "Cnee Has Received Cargo",
  3.17: "Picked Up Cargo",
  3.18: "Arrived At The Warehouse",
  3.19: "Delivered Cargo",
  "3.20": "Empty Return",
  4.1: "Delivered",
  5.1: "Unpaid",
  5.2: "Paid",
  5.3: "Refund",
  6.1: "Reject",
  6.2: "Cancelled",
};
export default {
  mixins: [trackTrace],

  props: {
    bookingInfo: { default: null },
    shipment: { default: null },
    request_quotation: { default: null },
    isNoLogin: { default: false },
    shipment_on_tms: { default: null },
    shipment_on_fast: { default: null },
    bookingID: { default: null },
    isPublic: { default: false },
  },
  components: {
    iconVAN,
    iconLCL,
    iconContainerTruck,
    VBTooltip,
    AppTimeline,
    AppTimelineItem,
    BImg,
    VueHtml2pdf,
    BDropdown,
    BDropdownItem,
    BButton,
    BFormTextarea,
    BCardText,
    BFormInput,
    BFormCheckbox,
    BFormRadioGroup,
    BFormRadio,
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,
    BInputGroupPrepend,
    BFormDatepicker,
    BRow,
    BCol,
    BTable,
    BCard,
    BCardText,
    FeatherIcon,
    RoutingDetailsContainer,
    RoutingDetailsLCL,
    RoutingDetailsVan,
  },
  data() {
    return {
      appLogoImage: require("@/assets/images/logo/logo.svg"),
      userData: JSON.parse(localStorage.getItem("userData")),
      group_: null,
      trace_trace_list: [],
      listService: {
        3: "LCL",
        1: "AIR",
        2: "FCL",
        4: "Customs",
        5: "containerTrucking",
        6: "van",
      },
      listsTrackTrace: [
        { id: "2.1", text: "Release Booking", group: 1, idStatus: 63 },
        {
          id: "2.2",
          text: "Received Revise Request",
          group: 1,
          idStatus: 62,
        },
        {
          id: "2.3",
          text: "Planned Transportation",
          group: 1,
          idStatus: 7,
        },

        { id: "3.0", text: "Truck Information", group: 2 },
        { id: "3.1", text: "Empty Picked Up", group: 2, idStatus: 25 },
        { id: "3.2", text: "Arrived At The Warehouse", group: 2, idStatus: 26 },
        { id: "3.3", text: "Picked Up Cargo", group: 2, idStatus: 27 },
        {
          id: "3.4",
          text: "Delivered Cargo To The Port",
          group: 2,
          idStatus: 28,
        },
        {
          id: "3.5",
          text: "Reached The Receiving Location",
          group: 2,
          idStatus: 29,
        },
        { id: "3.6", text: "Picked Up Cargo", group: 2, idStatus: 30 },
        {
          id: "3.7",
          text: "Reached The Delivery Location",
          group: 2,
          idStatus: 31,
        },

        { id: "3.8", text: "Delivered Cargo", group: 2, idStatus: 32 },
        { id: "3.9", text: "Cargo Loaded", group: 2, idStatus: 33 },
        {
          id: "3.10",
          text: "Arrived Destination Port",
          group: 2,
          idStatus: 34,
        },
        { id: "3.11", text: "Release", group: 2, idStatus: 35 },
        {
          id: "3.12",
          text: "Reached The Receiving Location",
          group: 2,
          idStatus: 36,
        },
        { id: "3.13", text: "Picked Up Cargo", group: 2, idStatus: 37 },
        {
          id: "3.14",
          text: "Reached The Delivery Location",
          group: 2,
          idStatus: 38,
        },
        { id: "3.15", text: "Delivered Cargo", group: 2, idStatus: 39 },
        { id: "3.16", text: "Cnee Has Received Cargo", group: 2, idStatus: 40 },
        { id: "3.17", text: "Picked Up Cargo", group: 2, idStatus: 41 },
        {
          id: "3.18",
          text: "Arrived At The Warehouse",
          group: 2,
          idStatus: 42,
        },
        { id: "3.19", text: "Delivered Cargo", group: 2, idStatus: 43 },
        { id: "3.20", text: "Empty Return", group: 2, idStatus: 44 },

        { id: "4.1", text: "Delivered", group: 3, idStatus: 8 },

        { id: "5.1", text: "Unpaid", group: 4, idStatus: 9 },
        { id: "5.2", text: "Paid", group: 4, idStatus: 11 },
        { id: "5.3", text: "Refund", group: 4, idStatus: 13 },
      ],

      shipment_detail: null,
      track_trace: {},
      trace_group_select_id: null,
      trace_group_select: [],
      trace_group: [
        { id: 1, text: "Booking Approval", children: [] },
        { id: 2, text: "In Transit ", children: [] },
        { id: 3, text: "Delivered ", children: [] },
        { id: 4, text: "Payment  ", children: [] },
      ],
    };
  },
  computed: {
    ...mapState("masterDataNoLogin", ["ports", "locations"]),
  },
  async mounted() {

    const url = this.isNoLogin ? "wr1Nologin" : "wr1";
    this.$store.dispatch("masterDataNoLogin/FETCH_ALL");

    useJwt
      .get(`wr1Nologin?objectType=GetBookingDetail`, {
        params: { search: { id: this.bookingID, bookingId: this.bookingID } },
      })
      .then((response) => {


        if (response.data.result?.shipment_detail || response.data.result?.[0]?.shipment_detail) {
          this.shipment_detail = JSON.parse(
            response.data.result.shipment_detail || response.data.result[0].shipment_detail
          );
        }
      });

    this.group_ = await this.getServiceStatusGroupPublic();

    useJwt
      .get(`wr1Nologin?objectType=TrackNTrace`, {
        params: { search: { bookingId: this.bookingID } },
      })
      .then((response) => {
        if (response.data.message == "success!") {
          let req = response.data.result || [];
          for (let index = 0; index < req.length; index++) {
            const element = req[index];
            //TODO track trace
            const shipment = JSON.parse(element.shipment_info);

            this.getTrackTrace(shipment, element.trucking_id);
          }
        }
      })
      .catch((error) => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$i18n.t("error"),
            text: this.$i18n.t("errorSystem"),
            icon: "XIcon",
            variant: "danger",
          },
        });
      });
  },
  methods: {
    isComponent() {
      console.log(
        this.request_quotation.service_type == 3 ||
          this.request_quotation.service_type == "LCL" ||
          this.request_quotation.service_type == "Lcl"
          ? "RoutingDetailsLCL"
          : this.request_quotation.service_type == 5 ||
            this.request_quotation.service_type == "CONTAINER_TRUCKING" ||
            this.request_quotation.service_type == "Container Trucking"
          ? "RoutingDetailsContainer"
          : this.request_quotation.service_type == 6 ||
            this.request_quotation.service_type == "VAN_TRUCKING" ||
            this.request_quotation.service_type == "Van Trucking"
          ? "RoutingDetailsVan"
          : ""
      );
      return this.request_quotation.service_type == 3 ||
        this.request_quotation.service_type == "LCL" ||
        this.request_quotation.service_type == "Lcl"
        ? "RoutingDetailsLCL"
        : this.request_quotation.service_type == 5 ||
          this.request_quotation.service_type == "CONTAINER_TRUCKING" ||
          this.request_quotation.service_type == "Container Trucking"
        ? "RoutingDetailsContainer"
        : this.request_quotation.service_type == 6 ||
          this.request_quotation.service_type == "VAN_TRUCKING" ||
          this.request_quotation.service_type == "Van Trucking"
        ? "RoutingDetailsVan"
        : "";
    },
    isComponentIcon() {
      return this.request_quotation.service_type == 3 ||
        this.request_quotation.service_type == "LCL" ||
        this.request_quotation.service_type == "lcl"
        ? "iconLCL"
        : this.request_quotation.service_type == 5 ||
          this.request_quotation.service_type == "CONTAINER_TRUCKING" ||
          this.request_quotation.service_type == "Container Trucking"
        ? "iconContainerTruck"
        : this.request_quotation.service_type == 6 ||
          this.request_quotation.service_type == "VAN_TRUCKING" ||
          this.request_quotation.service_type == "Van Trucking"
        ? "iconVAN"
        : "";
    },
    getTrackTrace(shipment, id) {
      try {
        let track_trace_status = JSON.parse(
          JSON.stringify(this.track_trace_status_default)
        );

        const trace_group_new = JSON.parse(JSON.stringify(this.trace_group));
        shipment.map((element) => {
          var listId = this.listsTrackTrace.find((e) => e.id == element.id);
          if (listId) {
            element.name = listId.text;
            element.group = listId.group;
            element.selected = true;
            return element;
          }
        });

        trace_group_new.map((e) => {
          e.children = shipment.filter((f) => f.group == e.id);
        });

        this.trace_trace_list.push({
          id,
          track_trace: track_trace_status,
          trace_group: trace_group_new,
        });

        console.log(this.trace_trace_list);
        this.trace_group_select_id = this.trace_trace_list[0].id;
        this.trace_group_select = this.trace_trace_list[0].trace_group;
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>
<style lang="scss">
.under-line {
  color: #2b938c;
  font-weight: bold;
  border-bottom: 3px solid #2b938c;
}
.w-70 {
  width: 70%;
}
// http://125.212.237.95:9020/cont/cust/uploadFile/02b3c06e-fb11-4489-9a16-07e604230ecd?apiKey=c7785f0b-8ffe-4623-9ccc-948037903b34&amp;name=1gateee.jpg
// http://125.212.237.95:9020/cont/cust/uploadFile/9129df9f-d3f6-475f-aa68-1f790ce44cf8?apiKey=c7785f0b-8ffe-4623-9ccc-948037903b34&amp;name=hoadon.pdf
h3.text-center.title-details {
  font-style: normal;
  line-height: 29px;
  color: #2a958d;
}
.body-0 {
  padding: 0;
}
.shipment-timeline {
  flex-basis: 60%;
}
.shipment-details {
  flex-basis: 30%;
  padding-top: 80px;
}
.list-details {
  list-style: none;
  display: flex;
  justify-content: flex-end;
  padding: 1.5rem;
  border-bottom: 1px solid #ebe9f1;
  &:first-child {
    border-top: 1px solid #ebe9f1;
  }
  .title {
    width: 40%;
  }
  .title-id {
    text-align: end;
    width: 60%;
  }
}

.track-trace {
  .track-trace_tabs {
    list-style: none;
    margin: 60px auto 0;
    width: 100%;
    padding: 0 !important;
  }
  .track-trace_tabs li {
    /* Makes a horizontal row */
    float: left;

    /* So the psueudo elements can be
			   abs. positioned inside */
    position: relative;
  }
  .track-trace_tabs a {
    /* Make them block level
		     and only as wide as they need */
    float: left;
    padding: 10px 60px;
    text-decoration: none;
    font-size: 18px;

    /* Default colors */
    color: black;
    background: #e4e4e4;

    /* Only round the top corners */
    -webkit-border-top-left-radius: 15px;
    -webkit-border-top-right-radius: 15px;
    -moz-border-radius-topleft: 15px;
    -moz-border-radius-topright: 15px;
    border-top-left-radius: 15px;
    border-top-right-radius: 15px;
  }
  .track-trace_tabs .active {
    /* Highest, active tab is on top */
    z-index: 3;
  }
  .track-trace_tabs .active a {
    /* Colors when tab is active */
    background: #2a958d;
    color: white !important;
  }
  .track-trace_tabs li:before,
  .track-trace_tabs li:after,
  .track-trace_tabs li a:before,
  .track-trace_tabs li a:after {
    /* All pseudo elements are 
		     abs. positioned and on bottom */
    position: absolute;
    bottom: 0;
  }
  /* Only the first, last, and active
		   track-trace_tabs need pseudo elements at all */
  .track-trace_tabs li:last-child:after,
  .track-trace_tabs li:last-child a:after,
  .track-trace_tabs li:first-child:before,
  .track-trace_tabs li:first-child a:before,
  .track-trace_tabs .active:after,
  .track-trace_tabs .active:before,
  .track-trace_tabs .active a:after,
  .track-trace_tabs .active a:before {
    content: "";
  }
  .track-trace_tabs .active:before,
  .track-trace_tabs .active:after {
    background: #2a958d;

    /* Squares below circles */
    z-index: 1;
  }
  /* Squares */
  .track-trace_tabs li:before,
  .track-trace_tabs li:after {
    background: #e4e4e4;
    width: 10px;
    height: 10px;
  }
  .track-trace_tabs li:not(:first-child) {
    margin-left: -20px;
  }

  .track-trace_tabs li:not(:first-child):before {
    left: -10px;
  }
  .track-trace_tabs li:after {
    right: -10px;
  }
  /* Circles */
  .track-trace_tabs li a:after,
  .track-trace_tabs li a:before {
    width: 20px;
    height: 20px;
    /* Circles are circular */
    -webkit-border-radius: 10px;
    -moz-border-radius: 10px;
    border-radius: 10px;
    background: #fff;

    /* Circles over squares */
    z-index: 2;
  }
  .track-trace_tabs .active a:after,
  .track-trace_tabs .active a:before {
    background: #e4e4e4;
  }
  /* First and last track-trace_tabs have different
		   outside color needs */
  .track-trace_tabs li:first-child.active a:before,
  .track-trace_tabs li:last-child.active a:after {
    background: #fff;
  }
  .track-trace_tabs li a:before {
    left: -20px;
  }
  .track-trace_tabs li a:after {
    right: -20px;
  }
  .card-white {
    background: #fff !important;
  }
}
</style>
